define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/query",
	"csi/config",
	"csi/heading/stateColorResolver",
	"csi/html",
	"csi/html/StateWidget",
	"csi/locale",
	"csi/xml"
], function(declare,domClass,query,config,stateColorResolver,html,StateWidget,locale,xml) {

	var	DRAFT = "OperationsReviewState:Draft",
	PENDING = "OperationsReviewState:Pending",
	APPROVED = "OperationsReviewState:Approved";

	_nameSpan = function(/*DOMNode*/eParent, /*String*/enumValue) {
		html.create("span", {
			"class": "dijitInline",
			innerText: locale.getEnumName(enumValue, true)
		}, eParent, "first");
	};

	return declare(StateWidget, {
		_processHtml: function(/*Context*/ctx, /*DOMNode*/dom) {
			// summary: apply styling for active state
			this.inherited(arguments);

            var eDraft = query(".draft", dom)[0];
            var ePending = query(".pending", dom)[0];
            var eApproved = query(".approved", dom)[0];

			var node = ctx.getNode();
			var owner = ctx.cache.getNode(node.__Parent__, true);

			var allowIssues = config.getNodeSetting(owner, "AllowIssues");
			if(allowIssues == null) {
				//when there is no setting allow issues null or undefined
				// TODO: Add AllowIssues to FactorySubtypeSettings
				// to make it work the same as AllowIssues in StoreOperationsSubtypeSettings
				allowIssues = true;
			}
			if (allowIssues) {
				_nameSpan(eDraft, DRAFT);
				_nameSpan(ePending, PENDING);
				_nameSpan(eApproved, APPROVED);
			} else {
				_nameSpan(eDraft, DRAFT);
				_nameSpan(eApproved, APPROVED);
			}

			// color the current state
			const css = stateColorResolver.getStateCss(node);
			
			switch (node.State) {
				case DRAFT: domClass.add(eDraft, css); break;
				case PENDING: domClass.add(ePending, css); break;
				case APPROVED: domClass.add(eApproved, css); break;
			}
		},

		onAccessActionGeneratePDF: function(/*Context*/ctx, /*Action*/action) {
            return xml.nodeHasRight(ctx.getNode(), xml.RIGHT_WRITE);
		}
	});
});